import { themedStyled } from 'common/styles/styletron.theme';
import Separator from 'components/common/separator';
import { Input } from 'components/elements';
import Text from 'components/elements/text';
import { CardSection } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { StyleObject } from 'styletron-standard';

import CruiseSaleCruiseTable from './cruise-table';
import { ScheduleCardHeader } from '../../../style';

export default function CruiseSaleCruiseCard() {
  const { t } = useTranslation();

  return (
    <CardSection>
      <ScheduleCardHeader $style={style}>
        <Text variant="HeadingXSmall">{t('ticketSales:cruise_detail')}</Text>
        <ScheduleCardHeaderRight>
          <Input
            type="check-box"
            name="approvalable.cruiseSales.0.reminder"
            label={t('ticketSales:set_reminder')}
            noMargin
          />
        </ScheduleCardHeaderRight>
      </ScheduleCardHeader>
      <Separator gap={22} />
      <CruiseSaleCruiseTable />
    </CardSection>
  );
}

const style: StyleObject | any = {
  flexDirection: 'column',
  '@media screen and (min-width: 768px)': {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
};

const ScheduleCardHeaderRight = themedStyled('div', {
  display: 'flex',
});
